import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import { STORE } from '@/core/store/core.store';
import { Prop } from 'vue-property-decorator';
import { FOOTER_TYPE } from '@/core/values/core.values';
import { _APP_STORE } from '@/core/values/app.values';

@Component({
  name: 'ed-layout-sidebar'
})
class EdLayoutSidebar extends Vue {

  @Prop() readonly footerCompact: boolean;
  @Prop({ default: true }) readonly showFooter: boolean;

  public headerHeight: number = 0;

  /* Computed */
  get marginContent(): any {
    return { marginTop: `${this.headerHeight}px` };
  }

  get sidebarHeight(): any {
    return { height: `calc(100% - ${this.headerHeight}px)` };
  }

  get isSidebarShown(): any {
    return this.$store.state.AppStore.sidebarShown;
  }

  get sidebarClass(): any {
    return {
      'sidebar-body--compact': this.$store.state.AppStore.footer.type == FOOTER_TYPE.COMPACT,
      'sidebar-body--full': this.$store.state.AppStore.footer.type == FOOTER_TYPE.NONE
    };
  }

  get hasHeader(): boolean {
    return this.$store.state.AppStore.header.visible;
  }

  /* Methods */
  setHeaderHeight() {
    let header = document.getElementById('eduac-layout-header');
    this.headerHeight = header ? header.offsetHeight : 0;
  }

  toggleSidebar() {
    this.$App.Store.toggleSidebar()
  }

  /* Hooks */
  mounted() {
    this.$App.Store.setSidebarButton(true);
    window.addEventListener('resize', this.setHeaderHeight);
    setTimeout(this.setHeaderHeight, 100);
  }

}

export default Vue.component('ed-layout-sidebar', EdLayoutSidebar);
